import { IconProps } from '../icon-props-interface';
import '../icons.scss';


export const IconDelete = ({ color = 'var(--color-primary-3)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g>
                <path d="M9.19219 5.17696L8.0963 5.13676L7.85871 11.625L8.9546 11.665L9.19219 5.17696Z" fill={color} />
                <path d="M7.07292 5.15686H5.97633V11.6451H7.07292V5.15686Z" fill={color} />
                <path d="M5.191 11.6248L4.95341 5.13656L3.85753 5.17679L4.09514 11.665L5.191 11.6248Z" fill={color} />
                <path d="M0 2.4519V3.5485H1.14267L2.04917 13.8498C2.07402 14.1329 2.31109 14.3501 2.59528 14.3501H10.4358C10.72 14.3501 10.9573 14.1328 10.9819 13.8497L11.8885 3.5485H13.0496V2.4519H0ZM9.9336 13.2535H3.09736L2.24347 3.5485H10.7877L9.9336 13.2535Z" fill={color} />
                <path d="M8.3159 0.350098H4.73365C4.22976 0.350098 3.81982 0.760035 3.81982 1.26393V3.00023H4.91642V1.44669H8.13313V3.00023H9.22973V1.26393C9.22973 0.760035 8.81979 0.350098 8.3159 0.350098Z" fill={color} />
            </g>
        </svg>
    </div>
);

export default IconDelete;
